export const BACKEND_WIDGET_TYPE_UNKNOWN = 0;
export const BACKEND_WIDGET_TYPE_ONE = 1;
export const BACKEND_WIDGET_TYPE_TWO = 2;

export const FRONTEND_WIDGET_TYPE_UNKNOWN = 'unknown';
export const FRONTEND_WIDGET_TYPE_ONE = 'one';
export const FRONTEND_WIDGET_TYPE_TWO = 'two';

export const WIDGET_TYPE_BACKEND_TO_FRONTEND = new Map([
  [BACKEND_WIDGET_TYPE_ONE, FRONTEND_WIDGET_TYPE_ONE],
  [BACKEND_WIDGET_TYPE_TWO, FRONTEND_WIDGET_TYPE_TWO],
  [BACKEND_WIDGET_TYPE_UNKNOWN, FRONTEND_WIDGET_TYPE_UNKNOWN],
]);

export const WIDGET_TYPE_FRONTEND_TO_BACKEND = new Map([
  [FRONTEND_WIDGET_TYPE_ONE, BACKEND_WIDGET_TYPE_ONE],
  [FRONTEND_WIDGET_TYPE_TWO, BACKEND_WIDGET_TYPE_TWO],
  [FRONTEND_WIDGET_TYPE_UNKNOWN, BACKEND_WIDGET_TYPE_UNKNOWN],
]);

export function convertWidgetTypeFromFrontendToBackend(widgetType: string) {
  if (WIDGET_TYPE_FRONTEND_TO_BACKEND.has(widgetType)) {
    return WIDGET_TYPE_FRONTEND_TO_BACKEND.get(widgetType);
  }
  return BACKEND_WIDGET_TYPE_UNKNOWN;
}

export function convertWidgetTypeFromBackendToFrontend(widgetType: number) {
  if (WIDGET_TYPE_BACKEND_TO_FRONTEND.has(widgetType)) {
    return WIDGET_TYPE_BACKEND_TO_FRONTEND.get(widgetType);
  }
  return FRONTEND_WIDGET_TYPE_UNKNOWN;
}

export function renderErrorStateIcon(): string {
  return `<gz-tooltip
    class="error-tooltip">
      <gz-icon size="24" name='ds-icon-notification_negative' color="var(--red-layout-300-primary)"></gz-icon>
    </gz-tooltip>`;
}
